/**
 * パジネーション
 * @see ABUI_doc__Component_Pagination.html
 */
if($('.pagination').length) {
  $('.pagination').off('.pgnt', 'a');
  $('.pagination').on('click.pgnt', 'a', function(e) {
    if (!$(this).parents('li').hasClass('disabled')) {
      $(this).parent().siblings('li').removeClass('active').end().addClass('active');
      e.preventDefault();
    }
  });
}
